// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2-C8R","resendInfoText":"OnGoingPaymentBox_resendInfoText__3H7JM"};